const cols = [
  { header: "Nome", isSortable: true, name: "name" },
  { header: "Processo", isSortable: true, name: "process" },
  { header: "Serviço", isSortable: true, name: "service" },
  { header: "Status", isSortable: true, name: "status" },
  { header: "ÚLT. Contato", isSortable: true, name: "last_contact" },
];

export { cols };
